import { SelectOption } from "../../../types/select";
import { isObject, isSelectOption, isUploadedDocument } from "../../libs/utils";

type GenericObject = Record<string, unknown>;

type TransformDynamicFieldsOptions = {
  selectOptionAsObject?: boolean;
};

const transformSelectOptionValue = (option: SelectOption, selectOptionAsObject: boolean) => {
  if (selectOptionAsObject) return { key: option?.value, value: option?.label };
  return option.value;
};

export const transformDynamicFields = (
  object: GenericObject,
  options: TransformDynamicFieldsOptions = {},
): GenericObject => {
  const { selectOptionAsObject = false } = options;

  if (!isObject(object.dynamicFields)) return object;

  const dynamicFields = object.dynamicFields as GenericObject;
  const transformed: GenericObject = {};
  const attachments: GenericObject[] = [];

  Object.entries(dynamicFields).forEach(([key, value]) => {
    if (isUploadedDocument(value)) {
      attachments.push({ [key]: { ...value?.document, documentId: value?.documentId } });
      return;
    }

    // Handle nested non-select objects
    if (isObject(value) && !isSelectOption(value)) {
      const transformedChild: GenericObject = {};
      Object.entries(value).forEach(([childKey, childValue]) => {
        transformedChild[childKey] = isSelectOption(childValue)
          ? transformSelectOptionValue(childValue, selectOptionAsObject)
          : childValue;
      });
      transformed[key] = transformedChild;
      return;
    }

    if (isSelectOption(value)) {
      transformed[key] = transformSelectOptionValue(value, selectOptionAsObject);
      return;
    }

    transformed[key] = value;
  });

  if (attachments.length > 0) transformed.attachment = attachments;

  return transformed;
};
